import { createActionConst } from '../../../utils/action.utils';

const PAYMENT_NAMESPACE = 'PAYMENT';

export const STORE_PAYMENT = createActionConst(PAYMENT_NAMESPACE, 'STORE_PAYMENT');
export const CLEAR_PAYMENT = createActionConst(PAYMENT_NAMESPACE, 'CLEAR_PAYMENT');
